<template>
    <dg-field-container :label_span="label_span" :field_span="field_span" :field_mark="field_mark"
                        :field_validate_message="validateMessage">
        <template v-slot:label>
            <dg-label-field v-if='label' :label="label" :translate="translateLabel" style="text-transform: capitalize;"></dg-label-field>
        </template>
        <template v-slot:field>
            <el-autocomplete class="inline-input w-100" v-model="field_value" @blur="updateValue" @select="updateValue" :placeholder="placeholder"
                             :disabled="disabled" :readonly="readonly" :fetch-suggestions="querySearch">
            </el-autocomplete>
            <slot name="field_note"></slot>
        </template>
    </dg-field-container>
</template>

<script>
    import inputField from './../mixins/inputField';

    export default {
        mixins: [inputField],
        props: {
            suggestions: {
                required: true,
            }
        },
        data () {
            return {
                field_value: null
            }
        },
        methods: {
            querySearch(queryString, cb) {
                // var links = this.suggestions;
                // var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                // call callback function to return suggestions
                cb(this.suggestions);
            }
        }
    }
</script>
